/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

export const MOVE_WHEEL_DELTA_THRESHOLD = 1;
export const ZOOM_WHEEL_DELTA_THRESHOLD = 1;
export const MIN_ZOOM_LEVEL = 0.25;
export const MAX_ZOOM_LEVEL = 1000;
export const DEFAULT_ZOOM_LEVEL = 0.25;
